export default function guest({ store})
{
    if (store.getters["auth/authenticated"])
    {
        return 'campaigns';
    }

    return false;
}
